import { META_FETCHED } from "../types";

export default function meta(state = {}, action = {}) {
  switch (action.type) {
    case META_FETCHED:
          return { ...state, ...action.meta };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/meta.js